module.exports = __webpack_public_path__ + "img/slack.70bbf31c.jpg";